"use client";
import * as S from "./styles.ts";
import { IIconGroupProps } from "./Icons/IconGroup";
import FooterContact, { TContactInfo } from "./Contact";
import Icons, { IIconGroup } from "./Icons";
import InternalLinks, { TLinkCategory } from "./InternalLinks";

type TIconGroupIcons = IIconGroupProps["icons"];

export interface FooterSectionComponentProps {
  internalLinks?: TLinkCategory[];
  iconGroups?: IIconGroup[];
  contact?: TContactInfo;
}

const FooterSectionComponent = ({
  internalLinks,
  iconGroups,
  contact,
}: FooterSectionComponentProps) => {
  return (
    <S.FooterWrapper>
      <S.FooterContentWrapper>
        <S.Container>
          <S.InnerContainer>
            <Icons groups={iconGroups} />
            {internalLinks && <InternalLinks internalLinks={internalLinks} />}
          </S.InnerContainer>
          {contact && <FooterContact contactInfo={contact} />}
        </S.Container>
      </S.FooterContentWrapper>
    </S.FooterWrapper>
  );
};

export default FooterSectionComponent;
